import { useFormContext } from 'react-hook-form'
import { TextField } from '@boltenergy-be/design-system'
import { getFieldError, getFieldName } from 'components/inputs/utils'
import { MeterNumberProps } from 'components/inputs/meter-number/types'
import { useTranslation } from 'next-i18next/pages'
import { isValidEAN } from 'utils/helpers'

const MeterNumber = ({ parentDotPath }: MeterNumberProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register(getFieldName('meterNumber', parentDotPath), {
        maxLength: {
          value: 18,
          message: t('validation:max.string', {
            attribute: t('meterDetails.fields.meterNumber.label'),
            length: 18
          })
        },
        required: t('validation:required'),
        validate: (value: number) => !isValidEAN(value.toString(10)) || t('commonFormFields:meterReading.errors.looksLikeEan')
      })}
      error={getFieldError('meterNumber', parentDotPath, errors)?.message}
      label={t('commonFormFields:meterNumber.label')}
      type="text"
    />
  )
}

export default MeterNumber
